import { Id } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import scheduleKeys from 'schedule/queries/shared/keys'
import keys from './shared/keys'
import { CrewRating } from './shared/types'

export function useAddShiftRating(rateCrew?: boolean) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: addShiftRating,
    onSuccess: () => {
      return client.invalidateQueries({ queryKey: scheduleKeys.all })
    },
  })

  async function addShiftRating({
    shiftId,
    raterId,
    rating,
  }: CrewRating): Promise<void> {
    return server.post(getUrl(rateCrew), {
      shift_id: shiftId,
      rater_id: raterId,
      rating: rating,
    })
  }
}

function getUrl(rateCrew?: boolean) {
  if (rateCrew) {
    return '/v2/managers/me/shifts/rate_crew'
  } else {
    return '/v2/helpers/me/shifts/rate_store'
  }
}

export function useAddMultipleShiftsRating(storeId?: Id) {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: addMultipleShiftRating,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: scheduleKeys.all }).catch(null)
      client.invalidateQueries({ queryKey: keys.all }).catch(null)
    },
  })

  async function addMultipleShiftRating(
    crewRatings: CrewRating[]
  ): Promise<void> {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }
    return server.post(
      `v2/managers/me/shifts/${storeId}/unrated_shifts`,
      crewRatings.map(crewRating => {
        return {
          shift_id: crewRating.shiftId,
          rater_id: crewRating.raterId,
          rating: crewRating.rating,
        }
      })
    )
  }
}
